<!-- 高校生成器 -->
<template>
  <div id='createClass' :style="{'backgroundImage': `url(${require('../../assets/img/bg.png')})`}">
  <!-- <div id='createClass' :style="{'backgroundImage': `url(${require('../../assets/img/bg.png')})`,'padding-top': adShow ? '20px' : ''}"> -->
    <!-- <div class="top-bar" @click='download'>
      <img class='tag-logo' src="../../assets/img/img_top.png" alt="">
    </div> -->
    <!-- <div class="bannerAd" v-if="adShow">
      <img class="bg" @click="toBSL" src="@/assets/img/banner-ad.png" alt="">
      <img class="close" @click="adShow = false" src="@/assets/img/banner-ad-close.png" alt="">
    </div> -->
    <img class="title" src="../../assets/img/title.png" alt="">
    <div class="desc">超级课程表是全中国几乎每个大学生都在使用的大学APP。输入你录取的学校和专业，我们会通过AI大数据，帮你提前查看你所录取专业的课程表。</div>
    <div class="select" :style="{'backgroundImage': `url(${require('../../assets/img/input-bg.png')})`}">
      <p class="select-title">查询课表</p>
      <div class="items">
        <div class="item-title">
          选择学校
        </div>
        <div class="item-content" @click='selectIt(0)' :style="{'color': school ? '#4D70B2' : '#C5D3ED'}">
          {{school || '请输入学校名称'}}
        </div>
      </div>
      <div class="items">
        <div class="item-title">
          输入专业
        </div>
        <div class="item-content" @click='selectIt(1)' :style="{'color': profession ? '#4D70B2' : '#C5D3ED'}">
          {{profession || '请输入专业名称'}}
          <!-- <input type="text" placeholder="输入院系名称" v-model='profession'> -->
        </div>
      </div>
    </div>
    <div class="enter">
      <button class="enter-button" @click='enterClass'>一键生成课表</button>
      <div class="tips">
        课表数据由超级课程表大数据模拟生成
      </div>
    </div>
    <div class="hot" v-if="hotList.length > 0">
      <img class="hot-title" src="../../assets/img/hot-title.png" alt="">
      <!-- <div class="hot-row" v-for="(item,index) in hotList" :key="index">
        <div class="hot-item" v-for="item1 in item" @click="hotClick(item1)" :key="item1.id">{{item1.schoolName}} l {{item1.academy}}</div>
      </div>  -->
      <div class="hot-row">
        <div class="hot-item"  v-for="(item,index) in hotList" @click="hotClick(item)" :key="item.id">{{item.schoolName}} l {{item.academy}}</div>
      </div> 
    </div>
    <!-- 弹窗 -->
    <div class="search" :class="popupShow ? 'popFadeIn' : 'popFadeOut'">
      <div class="mask" @click="popupShow = false;"></div> 
      <div class="search-container">
        <div class="search-title">
          {{searchTitle}}
          <span @click="popupShow = false;">取消</span>
          <span @click="closePopup">确认</span>
        </div>
        <div class="search-input">
          <img src="../../assets/img/search.png" alt="">
          <input type="text" :placeholder="searchPlaceholder" v-model='resultText' @input='searchResult' :autofocus='true'>
        </div>
        <div class="result" v-if='resultList.length>0'>
          <div class="result-item" v-for="(item,i) in resultList" :key='i' @click='chooseIt(item)'>{{item.name}}</div>
        </div>
        <div class="result" v-else>
          <div class="result-item" style="background: #fff;justify-content: center;" v-if='resultUnkonw && resultText !== ""'>查询不到结果</div>
        </div>
        <!-- <div class="item-pop">
          <div class="item-content item-school" @click='selectIt'>
            <input type="text" placeholder="输入学校名称" v-model='school' @blur='blurResize' @input='searchSchool' :autofocus='true'>
          </div>
          <div class="item-cancel" @click='cancelIt'>
            取消
          </div>
        </div> -->
      </div>
    </div>
    <!-- 提示 -->
    <div class="tip" v-if="tipShow">
      <div class="tip-container" :style="{'backgroundImage': `url(${require('../../assets/img/layer-bg.png')})`}">
        <h4>提示</h4>
        <p>超级课程表APP还没找到“你输入的大学”，请检查下您输入的学校名是否有错别字。如果确定你输入的学校名准确，那极小的可能性就是你的学校名没有录入系统，如果属于这种情况，本页面会记录下来并立刻排查，你可以过几天再来试试。</p>
        <div class="btn-group">
          <div @click='tipShow = false; trackEvent("重新输入");'>重新输入</div>
        </div>
      </div>
    </div>
    <!-- 提示 -->
    <div class="tip" v-if="tipProShow">
      <div class="tip-container" :style="{'backgroundImage': `url(${require('../../assets/img/layer-bg.png')})`}">
        <h4>提示</h4>
        <p>超级课程表APP还没找到“你输入的专业”，请检查下您输入的专业名是否有错别字。如果确定你输入的专业名准确，那极小的可能性就是你的专业名没有录入系统，如果属于这种情况，本页面会记录下来并立刻排查，你可以过几天再来试试。</p>
        <div class="btn-group">
          <div @click='tipProShow = false; trackEvent("重新输入");'>重新输入</div>
        </div>
      </div>
    </div>
    <!-- <div class="bottom" v-if='!isApp'>
            <img class='bottom-bar' src="../../assets/img/bottom-bar.png" @click='download' alt="">
        </div> -->
  </div>
</template>

<script>
import request from '@/assets/js/request.js'
// import allSchool from '@/assets/js/school.js'
import { debounce , getUrlParams } from '@/assets/js/tool.js'
import activeIcon from '@/assets/img/activeIcon.png'
import inactiveIcon from '@/assets/img/inactiveIcon.png'
import { RadioGroup, Radio, Toast } from 'vant'
import useSuperSdk from '@/assets/js/useSuperSdk.js'

export default {
  data() {
    return {
      school: localStorage.getItem('school') || '',
      schoolId: localStorage.getItem('schoolId') || '',
      resultText: '',
      resultUnkonw: false,
      popupShow: false,
      tipShow: false,
      tipProShow: false,
      profession: localStorage.getItem('faculty') || '', //院系
      professionExist: localStorage.getItem('faculty') ? true : false,
      schoolRadio: '1', // 年级  默认大二
      proRadio: '1', //学期  默认第一学期
      activeIcon,
      inactiveIcon,
      resultList: [],
      openId: '',
      isApp: false,
      searchTitle: '',
      searchPlaceholder: '',
      type: 0,
      hotList: [],
      adShow: true
    }
  },
  created() {
    this.wxsetShare()
    setTimeout(() => {
      this.openId = localStorage.getItem('openId')
      this.school = localStorage.getItem('school')
      this.schoolId = localStorage.getItem('schoolId')
      this.profession = localStorage.getItem('faculty')
    }, 1000)
  },

  mounted(){
    this.getHot();
  },

  methods: {
    wxsetShare() {
      let f = getUrlParams(location.href, 'f');
      const { setShare } = useSuperSdk()
      const title = '2023届大学新生课表统一查询入口'
      const link =  f == '' ? 'https://a.super.cn/previewCourse/#/' : 'https://a.super.cn/previewCourse/#/?=' + f;
      const desc = '点击提前查看录取大学所选专业课程表'
      // console.log(link);
      setShare(title, link, desc)
    },
    selectIt(type) {
      if(this.type !== type){
        this.resultText = ''
        this.resultList = []
      }
      if(!type){
        this.searchTitle = '选择学校'
        this.searchPlaceholder = '输入学校名称'
      }
      else{
        if(!this.school){
          Toast('请先选择学校');
          return;
        }
        this.searchTitle = '选择专业'
        this.searchPlaceholder = '输入专业名称'
        // this.getAcademy();
      }
      
      if(type == 0 && this.schoolId){
        this.resultText = this.school;
      }
      if(type == 1 && this.profession){
        this.resultText = this.profession;
      }
      this.type = type;
      this.popupShow = true;
      this.resultUnkonw = false;
    },
    cancelIt() {
      this.popupShow = false
      this.school = localStorage.getItem('school') || ''
    },
    chooseIt(item) {
      if(this.type == 0){
        this.school = item.name
        this.schoolId = item.schoolId
        // this.resultText = ''
        this.profession = ''
      }
      else{
        this.profession = item.name
        this.professionExist = true
      }
      this.popupShow = false
    },
    closePopup(){
      if(this.type == 0){
        this.school = this.resultText
      }
      else{
        this.profession = this.resultText
      }
      if(this.resultList.length > 0 && this.type == 0){
        if(this.resultText === this.resultList[0].name){
          this.schoolId = this.resultList[0].schoolId;
          this.resultText = ''
        }
      }
      if(this.resultList.length > 0 && this.type == 1){
        this.chooseIt(this.resultList[0]);
      }
      this.popupShow = false;
    },
    download() {
      window.location.href = 'http://redirect.super.cn/cjkcb/download?from=kebiao'
    },
    async enterClass() {
      // _hmt && _hmt.push(['_trackEvent', 'create-Class', 'createClass'])
      this.trackEvent("一键生成课表");
      if (this.school) {
        if(this.profession){
          if(!this.schoolId){
            this.tipShow = true;
            return;
          }
          if(!this.professionExist){
            this.tipProShow = true;
            return;
          }
          Toast.loading({
            message: '课表加载中...',
            forbidClick: true,
            loadingType: 'spinner',
            duration: 0,
          })

          // 查看是否所有学年都有课表
          const data1 = {
            schoolId: this.schoolId,
            specialtyName: this.profession,
          }
          const response1 = await request.post('/getGradeCourse.action', data1)
          if(response1.data){
            localStorage.setItem('hasCourse', JSON.stringify(response1.data));
          }
          // 发请求
          const data = {
            schoolId: this.schoolId,
            specialtyName: this.profession,
            grade: this.schoolRadio,
            term: this.proRadio,
            openId: localStorage.getItem('openId'),
            // schoolId: 66441,
            // specialty: '汽车电子技术',
            // grade: 2,
            // term: 1,
            // openId: '',
          }
          // const response = await request.post('/V2/CourseGeneration/queryCourse.action', data)
          const response = await request.post('/getCourse.action', data)
          Toast.clear()
          if (response.data) {
            localStorage.setItem('isback', 'false')
            localStorage.setItem('school', this.school)
            localStorage.setItem('schoolId', this.schoolId)
            localStorage.setItem('faculty', this.profession) //专业

            localStorage.setItem('grade', this.schoolRadio) //默认年级为大二
            localStorage.setItem('term', this.proRadio) //默认学期为第一学期

            response.data.school = localStorage.getItem('school')
            localStorage.setItem('response', JSON.stringify(response))
            localStorage.setItem('num1', response.data.num1)
            localStorage.setItem('num2', response.data.num2)
            localStorage.setItem('num3', response.data.num3)
            localStorage.setItem('num4', response.data.num4)
            localStorage.setItem('tag1', response.data.tag1)
            localStorage.setItem('tag2', response.data.tag2)
            localStorage.setItem('tag3', response.data.tag3)
            localStorage.setItem('tag4', response.data.tag4)
            localStorage.setItem('sameCourse', JSON.stringify(response.data.sameCourse))
            localStorage.setItem('otherCourse', JSON.stringify(response.data.otherCourse))

            this.$router.push('/course')
          } else {
            Toast.fail(response.message)
          }
        }
        else{
          Toast('请输入专业名称');
        }
      }
      else{
        Toast('请输入学校名称');
      }
    },
    searchResult: debounce(function () {
      this.resultList = []
      this.resultUnkonw = false
      if(this.type == 0){
        if(this.resultText){
          this.schoolId = '';
          localStorage.setItem('schoolId', '');
          this.getSchoolName();
        }
      }
      else{
        if(this.schoolId){
          if(this.resultText){
            this.professionExist = false;
            this.getAcademy();
          }
        }
      }
      
      // allSchool.forEach((element) => {
      //   if (element.name.indexOf(this.resultText) !== -1) {
      //     this.resultList.push(element)
      //   }
      // })
    }, 500),

    hotClick(data){
      this.school = data.schoolName;
      this.schoolId = data.schoolId;
      this.profession = data.academy;
      this.professionExist = true;

      this.enterClass();
    },

    async getHot(){
      const response = await request.post('/getHotSpecialty.action');
      let arr = response.data;
      // let arr = [{name: '复旦大学' , schoolId: '2001' , academy: '中国语言文学系'},{name: 'XX2' , schoolId: '2' , academy: '2XX'},{name: 'XX3' , schoolId: '3' , academy: '3XX'},{name: 'XX4' , schoolId: '4' , academy: '4XX'}]
      // const res = [];
      // for (let i = 0; i < arr.length; i += 2) {
      //     const chunk = arr.slice(i, i + 2);
      //     res.push(chunk);
      // }
      // this.hotList = res;
      this.hotList = response.data;
    },

    async getSchoolName(){
      const response = await request.post('/getSchool.action', {schoolName: this.resultText});
      if(this.resultList == response.data){
        return;
      }
      this.resultList = response.data;
      if (this.resultList.length === 0) {
        this.resultUnkonw = true
      }
    },

    async getAcademy(){
      const response = await request.post('/getSpecialty.action', {schoolId: this.schoolId, specialtyName: this.resultText});
      let arr = [];
      if(response.data && response.data.length){
        response.data.forEach((item)=>{
          arr.push({name: item})
        })
      }
      this.resultList = arr;
      if (this.resultList.length === 0) {
        this.resultUnkonw = true
      }
    },

    //异步请求们
    async getSchoolClassById(data) {
      const response = await request.post('/V2/CourseGeneration/loadCourse.action', data)
      // console.log(response);
      if (response.data) {
        localStorage.setItem('data', JSON.stringify(response.data))
        setTimeout(() => {
          this.$router.push(`/course`)
        }, 800)
      } else {
        alert(response.message)
      }
    },

    //事件监听
    trackEvent(name){
      _hmt.push(["_trackEvent", "previewClass", name])
    },

    toBSL(){
      window.location.href = 'http://a.super.cn/activities/bausch'
    }
  },
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
  watch :{
    popupShow(val){
      val ? document.body.style.overflow='hidden' : document.body.style.overflow='auto';
    },
    tipShow(val){
      val ? document.body.style.overflow='hidden' : document.body.style.overflow='auto';
    },
    tipProShow(val){
      val ? document.body.style.overflow='hidden' : document.body.style.overflow='auto';
    }
  }
}
</script>
<style lang='scss' scoped>
@import './index.scss';
</style>